import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import Cookies from "js-cookie";
import 'primeicons/primeicons.css'; 
import "./custom.scss";
import Loader from "./components/Loader";
import Login from "./pages/login";
import PrivateRoute from "./utils/PrivateRoute";

const HomePage = lazy(() => import("./pages/home"));
const ContactListPage = lazy(() => import("./pages/ContactListPage"));
const TestimonialPage = lazy(() => import("./pages/testimonial"));
const Report = lazy(() => import("./pages/report"));
const MediaVideo = lazy(() => import("./pages/mediaVideo"));
const Layout = lazy(() => import("./components/layout/Layout"));
import { ConfirmDialog } from "primereact/confirmdialog";


function App() {
  return (
    <div className="w-full h-full">
        <ConfirmDialog />
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Public route */}
          <Route index element={<Login />} />

          {/* Protected routes */}

  <Route element={<Layout />}>
    <Route path="dashboard" element={<HomePage />} />
     <Route path="report" element={<Report />} />
          <Route path="contactListPage" element={<ContactListPage />} />
           <Route path="testimonial" element={<TestimonialPage />} />
        <Route path="mediaVideo" element={<MediaVideo />} />
  </Route>


        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
